"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Membership = void 0;
const OrganizationConnectionBaseEntity_1 = require("../../entity/OrganizationConnectionBaseEntity");
class Membership extends OrganizationConnectionBaseEntity_1.OrganizationConnectionBaseEntity {
    constructor() {
        super(...arguments);
        // TODO - connect to tags entity
        this.tags = [];
    }
}
exports.Membership = Membership;
//# sourceMappingURL=membership.entity.js.map